import createModule from "../createModule"
import { getSelectedCustomForecast } from "modules/optimization/selectors/constraints"
import { getData, getRiskTargetPoint, getStatus, getChartDots } from "./selectors/data"
import { Creators } from "./model"
import view from "./view"

export default createModule({
  view,
  externalProps: state => ({
    portfolioShortId: state.global.selected.portfolio,
    account: state.global.selected.account,
  }),
  required: ["account", "portfolioShortId"],
  mapStateToProps: (state, props) => ({
    data: getData(state),
    status: getStatus(state),
    riskTargetPoint: getRiskTargetPoint(state, props),
    dots: getChartDots(state),
    selectedCustomForecast: getSelectedCustomForecast(state),
  }),
  actions: Creators,
})
